import PropTypes from "prop-types";
import React from "react";

import { Transition } from "../../Transition";

export const ArrowThin = (props) => {
  const { className, custom, role, size, style } = props;
  const activePath = "M2, 5 L8, 10 L14, 5";
  const inactivePath = "M2, 10 L8, 4 L14, 10";

  return (
    <svg {...getProps()}>
      <Transition {...getPathProps()} />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      style,
      viewBox: "0 0 16 16",
    };
  }

  function getPathProps() {
    const d = getActivePath(custom?.type);

    return {
      animate: { d },
      component: "path",
      componentProps: {
        fill: "none",
        strokeLinecap: "round",
        strokeWidth: "2",
      },
      initial: { d },
    };
  }

  function getActivePath(type) {
    return type === "active" ? activePath : inactivePath;
  }
};

ArrowThin.displayName = "ArrowThinIcon";

ArrowThin.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /**
   * custom allows for component to implement styling for a specific characteristic. There is no obligation for a
   * component to implement the custom prop.
   */
  custom: PropTypes.object,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

ArrowThin.defaultProps = {
  role: "img",
};
